import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AppContext from 'utils/app-context';

export const AdminGuard = ({ children }) => {
	const appContext = useContext(AppContext);

	if (appContext.isAdmin) {
		return children;
	}

	return <Navigate to="/" />;
};
